// @ts-nocheck
class WIprodesreadmore extends HTMLElement {
    connectedCallback() {
        const btn = this.querySelector('.WI_accor_para_des_open');
        const para = this.querySelector('.WI_accor_para_des_fullpara');
        if (!btn || !para) return;

        para.classList.add('is-clamped');

        if (para.scrollHeight > para.clientHeight) {
            btn.style.display = '';
        } else {
            para.classList.remove('is-clamped');
        }

        btn.addEventListener('click', () => {
            para.classList.remove('is-clamped');
            btn.style.display = 'none';
        });
    }
}

customElements.define('wi-prodes-readmore', WIprodesreadmore);
